<template>
  <b-modal v-model="innerModal" :title="title" no-close-on-backdrop no-close-on-esc>
    <div>{{ body }}</div>
    <slot></slot>

    <template v-slot:modal-footer="{ ok, cancel }">
      <stella-button variant="light" @click.native="cancel()">
        {{ $t('common.cancel') }}
      </stella-button>
      <stella-button variant="primary" @click.native="ok(); $emit('confirmed')" :disabled="disabledOkButton">
        {{ $t('common.ok') }}
      </stella-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    modal: Boolean,
    title: String,
    body: String,
    disabledOkButton: Boolean
  },
  data() {
    return {
      innerModal: false
    }
  },
  watch: {
    modal: function(value) {
      this.innerModal = value
    },
    innerModal: function(value) {
      this.$emit('toggleModal', value)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
